import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { getRoleByCategoria } from '@acme/auth/roles'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import { HousePlusIcon, PencilIcon, Trash2Icon } from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { type Supervisor, supervisor } from 'service/api'
import { ISupervisorEmpresa } from 'types'

export default function Supervisor() {
    const { data = [], isLoading } = supervisor.useFetch()

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header label={['Cadastros', 'Supervisores']} />
                <ContentGuide.DataGrid
                    onAdd
                    columns={[
                        {
                            field: 'id',
                            headerName: 'Código',
                            width: 170,
                            type: 'number',
                        },
                        {
                            field: 'categoriaId',
                            headerName: 'Categoria',
                            width: 140,
                            valueGetter: params => {
                                const { Usuario } =
                                    params.row as ISupervisorEmpresa
                                return getRoleByCategoria(Usuario.categoriaId)
                            },
                        },
                        {
                            field: 'nome',
                            headerName: 'Nome',
                            flex: 1,
                        },
                        {
                            field: 'email',
                            headerName: 'E-mail Supervisor',
                            width: 250,
                            valueGetter: params => {
                                const { Usuario } =
                                    params.row as ISupervisorEmpresa
                                return Usuario.email
                            },
                        },
                        {
                            ...optionsColumn,
                            field: '__associar',
                            renderCell: ({ id, row }) =>
                                hasPermission(['update', 'Supervisores']) &&
                                row.Usuario.categoriaId != 3 ? (
                                    <IconButton
                                        title="Associar empresa, centro de custo ou local"
                                        href={`${id}/associar`}
                                    >
                                        <HousePlusIcon />
                                    </IconButton>
                                ) : null,
                        },
                        {
                            ...optionsColumn,
                            field: '__editar',
                            renderCell: ({ id }) =>
                                hasPermission(
                                    ['update', 'Supervisores'],
                                    () => (
                                        <IconButton
                                            title="Editar"
                                            href={`${id}/editar`}
                                        >
                                            <PencilIcon />
                                        </IconButton>
                                    ),
                                ),
                        },
                        {
                            ...optionsColumn,
                            field: '__excluir',
                            renderCell: ({ id }) =>
                                hasPermission(
                                    ['delete', 'Supervisores'],
                                    () => (
                                        <IconButton
                                            title="Excluir"
                                            href={`${id}/excluir`}
                                        >
                                            <Trash2Icon className="text-red-500" />
                                        </IconButton>
                                    ),
                                ),
                        },
                    ]}
                    rows={data}
                    ToolbarProps={{
                        showQuickFilter: true,
                        exportButtonProps: {
                            fileName: 'exportacao-supervisores',
                        },
                    }}
                    loading={isLoading}
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function useSupervisoresOutletContext() {
    return useOutletContext<{
        data: Supervisor[]
    }>()
}
